var exports = {
  "g4": "InviteModal.module__loadingContainer___WXdpZk",
  "qy": "InviteModal.module__channelSubtitle___WXdpZk",
  "HA": "InviteModal.module__channelName___WXdpZk",
  "p": "InviteModal.module__channelIcon___WXdpZk",
  "ak": "InviteModal.module__inviteButton___WXdpZk",
  "UW": "InviteModal.module__warningContainer___WXdpZk",
  "QW": "InviteModal.module__warningIcon___WXdpZk",
  "i4": "InviteModal.module__warningText___WXdpZk",
  "xr": "InviteModal.module__expirationText___WXdpZk",
  "bv": "InviteModal.module__editLink___WXdpZk",
  "Wm": "InviteModal.module__detailedView___WXdpZk",
  "WT": "InviteModal.module__noChannelContent___WXdpZk",
  "Q9": "InviteModal.module__noChannelIcon___WXdpZk",
  "E_": "InviteModal.module__noChannelText___WXdpZk",
};

module.exports = exports;
